import i18n from "@/i18n";
import { PowerPlanEvent } from "@/services/powerPlans/types";
import moment from "moment";

export function powerPlanEventFromDate(powerPlanEvent: PowerPlanEvent): string {
    return i18n.d(new Date(powerPlanEvent.fromDate), "short");
}

export function powerPlanEventToDate(powerPlanEvent: PowerPlanEvent): string {
    if (powerPlanEvent.neverending) {
        return i18n.t("posts.neverending") as string;
    } else if (powerPlanEvent.toDate) {
        return i18n.d(new Date(powerPlanEvent.toDate), "short");
    } else {
        return i18n.t("posts.selectEndDate") as string;
    }
}

export function powerPlanEventTimeSpan(powerPlanEvent: PowerPlanEvent): string {
    if (powerPlanEvent.allDay) {
        return i18n.t("common.allday").toString();
    } else {
        return moment(powerPlanEvent.fromTime, "hh mm").format("HH:mm") +
            " - " + moment(powerPlanEvent.toTime, "hh mm").format("HH:mm");
    }
}
